module.exports = __webpack_public_path__ + "img/forearmcircumference.eb04b39a.jpeg";